/**
 * 文件导入相关常量配置
 */

// 音频文件最大时长（秒）：3小时
export const MAX_AUDIO_DURATION = 3 * 60 * 60;

// 音频文件最大大小（字节）：200MB
export const MAX_AUDIO_SIZE = 200 * 1024 * 1024;

// 支持的音频文件扩展名
export const ACCEPT_AUDIO_TYPES = ['.mp3', '.wav', '.m4a'];

// 支持的音频文件 MIME 类型
export const ACCEPT_AUDIO_MIME_TYPES = ['mpeg', 'mp3', 'wav', 'm4a'];

// 每日最多上传的音频文件个数   
export const MAX_AUDIO_COUNT = 10;

// 最大上传个数
export const MAX_UPLOAD_COUNT = 3;

// 轮询间隔（毫秒）
export const POLLING_INTERVAL = 5000;

// 默认权益数
export const DEFAULT_BENEFIT = 10;

// 单声道阈值
export const MONO_CHANNEL_THRESHOLD = 1;

// FFmpeg 相关配置
export const FFMPEG_CONFIG = {
  CORE_URL: '/ffmpeg-core.js',
  WASM_URL: '/ffmpeg-core.wasm',
} as const;